import axios from "axios";

type ModifyPasswordActionProps = {
  id: number;
  password: string;
  token: string;
};

export async function modifyPasswordAction(params: ModifyPasswordActionProps) {
  const token =
    sessionStorage.getItem("token") ?? localStorage.getItem("token");

  return await axios
    .put(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/users/modify-password`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
